/* =============================================================================
   pl-v9.js — "Conoce tu producto": puntos que hacen zoom tipo lupa (gen-secciones11.js)
   La entrada la dispara motion.js (data-anim="pan"); todo con anime.js, solo transform/opacity.
   ========================================================================== */
(function () {
  'use strict';
  var ONX = (window.ONX = window.ONX || {});
  ONX.effects = ONX.effects || {};
  var A = function () { return window.anime; };

  function setup(box) {
    if (box._pan) return box._pan;
    var prod = box.querySelector('[data-pan-prod]'), dots = box.querySelectorAll('[data-pan-dot]'), tabs = box.querySelectorAll('[data-pan-tab]');
    var lupas = {}; box.querySelectorAll('[data-pan-lupa]').forEach(function (l) { lupas[l.getAttribute('data-pan-lupa')] = l; });
    var cards = box.querySelectorAll('[data-pan-card]'), seg = Number(box.getAttribute('data-auto')) || 0;
    var cur = -1, tocado = false, visible = false, espera = false, prog = null, zoom = window.matchMedia('(min-width: 990px)').matches ? 1.35 : 1.5;
    function ir(i, mano) {
      var a = A(); i = (i + dots.length) % dots.length;
      if (mano) { tocado = true; var g = box.querySelector('[data-pan-hint]'), mn = box.querySelector('[data-pan-mano]'); if (g) g.hidden = true; if (mn) mn.classList.add('is-off'); }
      if (i === cur && !mano) return;
      var ant = cur; cur = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', String(k === i)); t.querySelector('i').style.transform = 'scaleX(0)'; });
      var lupa = lupas[i], vieja = lupas[ant];
      cards.forEach(function (c, k) { c.hidden = k !== i; });
      prod.classList.toggle('has-lupa', !!lupa);
      if (!lupa) { prod.style.transformOrigin = dots[i].style.left + ' ' + dots[i].style.top; prod.style.setProperty('--z', zoom); }
      else prod.style.setProperty('--z', 1);
      if (!a) { Object.keys(lupas).forEach(function (k) { lupas[k].hidden = lupas[k] !== lupa; }); return; }
      if (vieja && vieja !== lupa) a.animate(vieja, { scale: 0.3, opacity: 0, rotate: 8, duration: 380, ease: 'inBack(1.4)', onComplete: function () { vieja.hidden = true; } });
      if (lupa) {
        // la burbuja nace en el punto y crece con un giro 3D; dentro, la foto se acerca despacio
        var d = dots[i], ox = (parseFloat(d.style.left) - parseFloat(lupa.style.left)) / 0.62, oy = (parseFloat(d.style.top) - parseFloat(lupa.style.top)) / 0.62 * (prod.offsetHeight / prod.offsetWidth) / 1;
        lupa.style.transformOrigin = Math.max(0, Math.min(100, ox)) + '% ' + Math.max(0, Math.min(100, oy)) + '%';
        lupa.hidden = false;
        a.animate(prod, { scale: 1, duration: 600, ease: 'outExpo' });
        a.animate(lupa, { scale: [0.05, 1], opacity: [0, 1], rotate: [-14, 0], rotateY: [55, 0], duration: 950, delay: vieja ? 200 : 0, ease: 'outBack(1.5)' });
        a.animate(lupa.querySelector('img'), { scale: [1.35, 1.08], duration: 4200, delay: 150, ease: 'outQuad' });
      } else a.animate(prod, { scale: [ant < 0 ? 1 : 1.12, zoom], duration: 900, ease: 'outExpo' });
      a.animate(dots[i], { scale: [0.6, 1.25, 1], duration: 700, ease: 'outBack(2)' });
      a.animate(cards[i], { opacity: [0, 1], y: [18, 0], filter: ['blur(6px)', 'blur(0px)'], duration: 650, ease: 'outExpo' });
      a.animate(cards[i].querySelectorAll('.pan__num, .pan__t, .pan__txt'), { opacity: [0, 1], x: [-14, 0], duration: 600, delay: a.stagger(70, { start: 80 }), ease: 'outExpo' });
      if (prog) prog.pause();
      if (seg && !tocado) {
        prog = a.animate(tabs[i].querySelector('i'), { scaleX: [0, 1], duration: seg * 1000, ease: 'linear',
          onComplete: function () { if (tocado) return; if (visible && !document.hidden) ir(cur + 1); else espera = true; } });
      }
    }
    // al soltar la sección la foto vuelve a su tamaño (sin zoom fuera de vista)
    new IntersectionObserver(function (en) {
      visible = en[0].isIntersecting;
      if (visible && espera && !tocado) { espera = false; ir(cur + 1); }
    }, { threshold: 0.35 }).observe(box);
    var fl = box.querySelector('.pan__float'), st = box.querySelector('.pan__stage'), raf = 0;
    st.addEventListener('pointermove', function (e) {
      var r = st.getBoundingClientRect(), px = (e.clientX - r.left) / r.width - 0.5, py = (e.clientY - r.top) / r.height - 0.5;
      cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { st.style.transform = 'perspective(900px) rotateY(' + (px * 10).toFixed(2) + 'deg) rotateX(' + (-py * 10).toFixed(2) + 'deg)'; });
    });
    st.addEventListener('pointerleave', function () { st.style.transform = ''; });
    st.style.transition = 'transform .35s ease-out';
    dots.forEach(function (d, k) { d.addEventListener('click', function () { ir(k, true); }); });
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { ir(k, true); }); });
    prod.addEventListener('click', function (e) { if (!e.target.closest('[data-pan-dot]')) ir(cur + 1, true); });
    // tocar la lupa la abre en grande (tocar fuera o Esc la cierra)
    Object.keys(lupas).forEach(function (k) {
      var l = lupas[k], abrir = function () {
        var a = A(), v = document.createElement('div');
        v.className = 'pan__visor'; v.setAttribute('role', 'dialog'); v.setAttribute('aria-label', l.getAttribute('aria-label'));
        v.innerHTML = '<img alt="" src="' + l.getAttribute('data-grande') + '"><b aria-hidden="true">×</b>';
        box.appendChild(v);
        var cerrar = function () { document.removeEventListener('keydown', esc); if (a) a.animate(v, { opacity: 0, duration: 250, ease: 'outQuad', onComplete: function () { v.remove(); } }); else v.remove(); };
        var esc = function (e) { if (e.key === 'Escape') cerrar(); };
        v.addEventListener('click', cerrar); document.addEventListener('keydown', esc);
        if (a) { a.animate(v, { opacity: [0, 1], duration: 300, ease: 'outQuad' }); a.animate(v.querySelector('img'), { scale: [0.6, 1], rotateY: [25, 0], opacity: [0, 1], duration: 700, ease: 'outBack(1.4)' }); }
        try { if (window.clarity) clarity('set', 'conoce_producto', String(+k + 1)); } catch (err) {}
      };
      l.addEventListener('click', abrir);
      l.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(); } });
    });
    return (box._pan = { ir: ir });
  }

  ONX.effects.pan = function (el, a, o) {
    var box = el.closest('[data-pan]'), p = setup(box);
    var prod = el.querySelector('.pan__float'), dots = el.querySelectorAll('.pan__dot');
    a.utils.set(dots, { scale: 0 });
    a.animate(el.querySelector('.pan__halo'), { scale: [0.6, 1], opacity: [0, 1], duration: 1200, delay: o.delay, ease: 'outExpo' });
    a.animate(dots, { scale: [0, 1], duration: 800, delay: a.stagger(140, { start: o.delay + 700 }), ease: 'outBack(2.4)' });
    if (Number(box.getAttribute('data-auto'))) setTimeout(function () { p.ir(0); }, o.delay + 700 + dots.length * 140 + 300); // con 0, espera a que la clienta toque
    return a.animate(prod, { opacity: [0, 1], y: [70, 0], rotate: [-10, 0], scale: [0.85, 1], duration: 1300, delay: o.delay, ease: 'outExpo' });
  };
  // sin anime.js o en el editor: que funcione igual al tocar
  function init(root) { (root || document).querySelectorAll('[data-pan]').forEach(setup); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
